export default __webpack_public_path__ + "a83aaef5cb5251659dcebcab97d7c671.jpg";